import React from 'react';

import { ThemeProvider, createTheme } from '@mui/material/styles';
import ItemSearch from './components/ItemSearch';

const theme = createTheme({
  palette: {
    primary: {
      main: '#12239E'
    }
  }
});



function App() {
  return (
    <ThemeProvider theme={theme}>
        <ItemSearch />
    </ThemeProvider>
  );
}

export default App;